// Module
var code = `<modal on-api-ready="\$ctrl.onModalReady"">
  <modal-header>
    <h1>Credit scoring</h1>
  </modal-header>
  <modal-body>
    <div class="grid">
      <cart>
        <cart-header>
          <h2>Customer Data</h2>
        </cart-header>
        <cart-body>
          <credit-scoring-modal-customer-details
            loan-application-details="\$ctrl.loanApplicationDetails"
          ></credit-scoring-modal-customer-details>
        </cart-body>
      </cart>
      <cart>
        <cart-header class="header--two-columns">
          <h2>Score analysis</h2>
          <span class="text-subtle">Generated on {{\$ctrl.generationTime | prettyDateTime}}</span>
        </cart-header>
        <cart-body>
          <cart-body-title>
            Repayment probability
          </cart-body-title>
          <score class="text--headline">
            <score-value ng-if="\$ctrl.score">{{(\$ctrl.score.prediction * 100).toFixed(0)}}%</score-value>
            <score-text ng-if="\$ctrl.score" class="color-{{\$ctrl.getScoreRange()[1]}}">{{\$ctrl.getScoreRange()[2]}}</score-text>
          </score>
          <score-progress>
            <score-progress-bad>0%</score-progress-bad>
            <score-progress-poor>50%</score-progress-poor>
            <score-progress-average>60%</score-progress-average>
            <score-progress-good>70%</score-progress-good>
            <score-progress-excellent>80%</score-progress-excellent>
            <score-progress-outstanding>90%</score-progress-outstanding>
          </score-progress>
          <div class="chart-container" ng-if=\$ctrl.score>
            <credit-scoring-modal-legend labels="\$ctrl.labels" score="\$ctrl.score"></credit-scoring-modal-legend>
            <credit-scoring-modal-score-chart labels="\$ctrl.labels" score="\$ctrl.score"></credit-scoring-modal-score-chart>
          </div>
        </cart-body>
      </cart>
    </div>
    <cart class="cart--large"
          ng-if="\$ctrl.loanApplicationDetails">
      <cart-header>
        <h2>Loan application details</h2>
      </cart-header>
      <cart-body>
        <credit-scoring-modal-loan-application-details
          loan-application-details="\$ctrl.loanApplicationDetails"
        ></credit-scoring-modal-loan-application-details>
      </cart-body>
    </cart>
    <cart class="cart--large">
      <cart-header>
        <h2>First 5 amortizations</h2>
      </cart-header>
      <cart-body>
        <amortization-preview
          amortization-preview="\$ctrl.loanApplicationDetails.amortizationSchedule"
          config="\$ctrl.amortizationPreviewConfig">
        </amortization-preview>
      </cart-body>
    </cart>
    <cart class="cart--large">
      <cart-header>
        <h2>The algorithm</h2>
      </cart-header>
      <cart-body>
        {{\$ctrl.scoreDescription.lightGBMmodel}}
      </cart-body>
    </cart>
    <div class="grid">
      <cart>
        <cart-header>
          <h2>Model performance metrics</h2>
        </cart-header>
        <cart-body>
          <cart-body-title>Model performance</cart-body-title>
          <div class="columns--space-between">
            <div ng-if="\$ctrl.scoreDescription.totalDatabaseSize">
              <span>Database size</span>
              <span>{{\$ctrl.scoreDescription.totalDatabaseSize}}</span>
            </div>
            <div ng-repeat="task in \$ctrl.scoreDescription.trainingTime">
              <span>{{task.task + ' time'}}</span>
              <span>{{task.time + 's'}}</span>
            </div>
          </div>
          <cart-body-title>Evaluation metrics</cart-body-title>
          <div class="columns--space-between">
            <div ng-repeat="metric in \$ctrl.scoreDescription.metrics | filter: \$ctrl.isMetricDisplayed">
              <span>{{metric.metric}}</span>
              <span>{{metric.score + '%'}}</span>
            </div>
          </div>
        </cart-body>
      </cart>
      <cart ng-if="\$ctrl.scoreDescription">
        <cart-header>
          <h2>Model confusion matrix</h2>
        </cart-header>
        <cart-body>
          <credit-scoring-modal-model-confusion-matrix
            score-description="\$ctrl.scoreDescription"
          ></credit-scoring-modal-model-confusion-matrix>
        </cart-body>
      </cart>
    </div>
    <cart ng-if="\$ctrl.scoreDescription.featureImportance['allFeatures'].length > 0" class="cart--large">
      <cart-header>
        <h2>{{\$ctrl.featureTitle(30, '')}}</h2>
      </cart-header>
      <cart-body>
        <cart-body-title>
          {{\$ctrl.featureDescription('')}}
        </cart-body-title>
        <credit-scoring-modal-features
          feature-name="'allFeatures'"
          score-description="\$ctrl.scoreDescription">
        </credit-scoring-modal-features>
      </cart-body>
    </cart>
    <cart ng-if="\$ctrl.scoreDescription.featureImportance['demographicFeatures'].length > 0" class="cart--large">
      <cart-header>
        <h2>{{\$ctrl.featureTitle(10, 'demographic')}}</h2>
      </cart-header>
      <cart-body>
        <cart-body-title>
          {{\$ctrl.featureDescription('demographic')}}
        </cart-body-title>
        <credit-scoring-modal-features
          feature-name="'demographicFeatures'"
          score-description="\$ctrl.scoreDescription">
        </credit-scoring-modal-features>
      </cart-body>
    </cart>
    <cart ng-if="\$ctrl.scoreDescription.featureImportance['creditHistoryFeatures'].length > 0" class="cart--large">
      <cart-header>
        <h2>{{\$ctrl.featureTitle(10, 'credit history')}}</h2>
      </cart-header>
      <cart-body>
        <cart-body-title>
          {{\$ctrl.featureDescription('credit history')}}
        </cart-body-title>
        <credit-scoring-modal-features
          feature-name="'creditHistoryFeatures'"
          score-description="\$ctrl.scoreDescription">
        </credit-scoring-modal-features>
      </cart-body>
    </cart>
    <cart ng-if="\$ctrl.scoreDescription.featureImportance['depositsFeatures'].length > 0" class="cart--large">
      <cart-header>
        <h2>{{\$ctrl.featureTitle(10, 'savings history')}}</h2>
      </cart-header>
      <cart-body>
        <cart-body-title>
          {{\$ctrl.featureDescription('savings history')}}
        </cart-body-title>
        <credit-scoring-modal-features
          feature-name="'depositsFeatures'"
          score-description="\$ctrl.scoreDescription">
        </credit-scoring-modal-features>
      </cart-body>
    </cart>
    <cart ng-if="\$ctrl.scoreDescription.featureImportance['loanFeatures'].length > 0" class="cart--large">
      <cart-header>
        <h2>{{\$ctrl.featureTitle(10, 'loan application')}}</h2>
      </cart-header>
      <cart-body>
        <cart-body-title>
          {{\$ctrl.featureDescription('loan application')}}
        </cart-body-title>
        <credit-scoring-modal-features
          feature-name="'loanFeatures'"
          score-description="\$ctrl.scoreDescription">
        </credit-scoring-modal-features>
      </cart-body>
    </cart>
  </modal-body>
  <modal-footer>
    <button type="button" ng-click="\$ctrl.close()" class="btn">
      Close
    </button>
    <button type="button" ng-click="\$ctrl.print()" class="btn btn-primary">
      Print
    </button>
  </modal-footer>
</modal>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;